module.exports = __webpack_public_path__ + "static/media/6_2.018f0068.png";